import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CommonService} from './common.service';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  endpoint = 'common/message';
  constructor(private commonService: CommonService, public router: Router) { }

  async sendMessage(model: any) {
    try {
      await this.commonService.insertItem(this.endpoint, model);
    } catch (e) {
      throw e;
    }
  }

  async sendReminder(model: any) {
    try {
      await this.commonService.insertItem('common/message/reminder', model);
    } catch (e) {
      throw e;
    }
  }

  /**
   * Description: Get user's last message
   */
  async getLastMessage() {
    try {
      const messageRequest = await this.commonService.getList('messages/last');
      return messageRequest.object.length > 0 ? messageRequest.object[0] : null;
    } catch (e) {
      throw e;
    }
  }

  async getUserUnreadMessagesTotal() {
    try {
      const countRequest = await this.commonService.getList('messages/count');
      return countRequest.object;
    } catch (e) {
      throw e;
    }
  }
  /**
   * Description: Get user's last message
   */
  async getMessageById(id: number) {
    try {
      const messageRequest = await this.commonService.getList(`messages/id?id=${id}`);
      return messageRequest.object.length > 0 ? messageRequest.object[0] : null;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Description: Get user's all messages
   */
  async getMyMessages() {
    try {
      const messageRequest = await this.commonService.getList('messages');
      return messageRequest.object;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Description: Get all users' messages
   */
  async getAllMessages() {
    try {
      const messageRequest = await this.commonService.getList('messages/all');
      return messageRequest.object;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Description: Send private message to parent
   * param message
   */
  async sendParentMessage(message: any) {
    try {
      await this.commonService.insertItem('messages', message);
    } catch (e) {
      throw e;
    }
  }

  async displayMessage(id: number) {
    await this.router.navigate([`/home/message/${id}`]);
  }

  async markMessageAsSeen(model: any) {
    try {
      await this.commonService.updateItem('messages/message/seen', model);
    } catch (e) {
      throw e;
    }
  }
}
